import { toast } from '@/components/toast';
import { deleteAvatar } from '@/pages/avatar/api';
import { useAnalytics } from '@/services/analytics';
import { GET_PRESENTERS_KEY, GET_PRESENTERS_KEY_TYPE } from '@/state/presenters/presenters';
import { MixPanelEvent } from '@/utils/types';
import { ImageType } from '@d-id/types';
import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { AvatarType, MixpanelGroupEventDelete } from '../common';
import { VALIDATE_USER_CAPPING_QUERY_KEY } from './useValidateUserCapping';

export function useDeleteAvatar() {
    const mixpanel = useAnalytics();
    const queryClient = useQueryClient();

    return useMutation(deleteAvatar, {
        async onSuccess() {
            await queryClient.invalidateQueries([GET_PRESENTERS_KEY, GET_PRESENTERS_KEY_TYPE(ImageType.Upload)]);
            await queryClient.invalidateQueries(VALIDATE_USER_CAPPING_QUERY_KEY);
            mixpanel?.track(MixpanelGroupEventDelete.Avatar, {
                event: MixPanelEvent.SUCCESS,
                itemType: AvatarType.Express,
            });
        },

        onError(error: AxiosError<{ kind: string; description?: string }>) {
            const kind = error?.response?.data?.kind;
            mixpanel?.track(MixpanelGroupEventDelete.Avatar, {
                kind,
                event: MixPanelEvent.ERROR,
                itemType: AvatarType.Express,
            });
            toast.error({ title: 'Failed to delete avatar, please try again', toastId: `delete-presenter-error` });
        },
    });
}
